module.exports = __webpack_public_path__ + "img/select-arrow.c55e8de7.svg";